<app-header></app-header>
<section class="section product-view-section grey-bg" (scroll)="onScroll($event)">
  <ul class="breadcrumb pdp-breadcrumb floating-breadcrumb">
    <li>
      <span>Brand</span>
      <i class="ri-arrow-right-s-line"></i>
    </li>
    <li>
      <span>{{capitalizeFirstLetterOfEachWord( selectedBrandNameForHeader)}}</span>
      <!-- <i class="ri-arrow-right-s-line"></i> -->
    </li>
  </ul>

  <div class="product-detail-card">
    <div class="row2 mx-0">
      <div class="col-18 pl-0 pt-0">
        <mat-card class="mat-card-1 brand-group-section-height company-group-card scrollbar-1">
          <div class="mat-header">
            <div class="d-flex">


              <div class="company-logo-section ">
                <img src="{{imgPrefix}}{{groupsBasedOnBrandsList[0]?.value?.brandImageLink}}" alt=""
                  onerror="this.src='../../../assets/img/NoImg.png'">
              </div>

              <h1>{{capitalizeFirstLetterOfEachWord( selectedBrandNameForHeader)}} </h1>
            </div>
            <span class="panel-title-lable">Category List</span>
          </div>


          <mat-card-content>

            <mat-accordion class="mat-accordion-1" multi="false">

              <mat-expansion-panel *ngFor="let groupData of groupsBasedOnBrandsList; let i = index"
                [expanded]="expandedPanelIndex === i" (opened)="expandedPanelIndex = i"
                (closed)="expandedPanelIndex = null">
                <mat-expansion-panel-header (click)="openGroup(groupData?.value?.categoryCode,'', i,groupData?.key)">

                  <mat-panel-title>

                    <img src="https://img.moglimg.com/{{groupData.value?.categoryImageLink}}" alt=""
                      onerror="this.src='../../../assets/img/NoImg.png'">
                    <span class="company-panel-title"> {{ groupData?.key }} </span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="group-section scrollbar-1">
                  <span class="panel-title-lable-2">Groups</span>
                  <ul class="group-list">
                    <li class="group-list-li" (click)="openSingleVariants(groupData.key, false)"> Other Products</li>
                  </ul>
                  <ul class="group-list" *ngFor="let group of groupData?.value?.groupingDetails">
                    <li class="group-list-li" (click)="navigateToGroup(group.idGroup)">{{ group.cisGroupName }}
                    </li>
                  </ul>
                </div>
              </mat-expansion-panel>
              <!-- <mat-expansion-panel
                (opened)="panelOpenState = true"
                (closed)="panelOpenState = false"
              >
              </mat-expansion-panel> -->
            </mat-accordion>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-82 pl-0 pr-0 pt-0">
        <mat-card class="mat-card-1 brand-group-section-height product-varient-table">
          <!-- <img mat-card-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu"> -->
          <mat-card-content class="">
            <section class="varients-group-section"
              [ngClass]="{ 'hidden': expandedGroupIdForViewMore !== null|| singleVariantFlag}"
              *ngFor="let groupDetails of groupListDataByBrandName | keyvalue; let i= index" #sectionRef
              [id]="groupDetails.key">
              <div class="d-flex justify-between w-100">
                <div class="d-flex varients-group-header">
                  <img class="mr-10" src="{{imgPrefix}}{{groupDetails.value?.elasticGroupDetails[0]?.mainImageLink}}"
                    alt="" onerror="this.src='../../../assets/img/NoImg.png'" />
                  <div>
                    <span>{{capitalizeFirstLetterOfEachWord( selectedBrandNameForHeader)}}</span>
                    <h2>{{groupDetails.value?.elasticGroupDetails[0]?.cisGroupName}} </h2>
                  </div>
                </div>
                <button mat-button class="btn-basic" (click)="toggleViewMore(groupDetails.key)" color="Blue2"
                  *ngIf="groupDetails.value?.productCount > 5">
                  {{ isExpanded(groupDetails.key) ? 'View Less' : 'View More' }}
                </button>

              </div>
              <div class="mog3_msnsearchtable product-varient-table-section " [ngClass]="{'table-max-height': isExpanded(groupDetails.key),
                  'table-min-height': !isExpanded(groupDetails.key)}">
                <table mat-table [dataSource]="groupDetails.value?.elasticGroupDetails" multiTemplateDataRows>
                  <ng-container matColumnDef="MSNItemDescription">
                    <th mat-header-cell *matHeaderCellDef class="border-right">
                      MSN <br /> Item Description
                    </th>
                    <td mat-cell *matCellDef="let element" class="border-right">
                      <div class="d-flex align-items-center justify-between">

                     
                      <span class="font-500 d-flex align-items-center">
                        {{ element?.moglixPartNumber }}
                      
                      </span>
                        <span class="copy-icon-button"
                          (click)="copyToClipboard(element?.moglixPartNumber, copyTooltip, $event)"
                          matTooltip="Copy MSN" #copyTooltip="matTooltip" matTooltipPosition="above">
                   <i  class="ri-file-copy-line"></i>
                        </span>
                         </div>
                      <div class="atom-tooltip">
                        <span class="link text-truncate "> {{ element?.productName }}
                          <span class="atom-tooltiptext tooltip-right table-tooltip">{{ element?.productName }}</span>
                        </span>
                      </div>
                      <span class="link text-truncate" *ngIf="element.productName == null">-
                      </span>
                    </td>
                  </ng-container>

                  <ng-container *ngFor="let column of getDynamicColumnsMapValue(groupDetails.key); let i= index"
                    matColumnDef="{{column}}">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p71">
                      <div class="flex items-center">
                        {{capitalizeFirstLetterOfEachWord(column)}}
                        <a mat-icon-button class="table-header-sort">
                          <i class="ri-arrow-up-down-fill"
                            (click)="displaySortedGroupDetails(groupDetails.key,column)"></i>
                        </a>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-width-p71">
                      {{ element?.attributeValuesForPart[column] }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="uom">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p80">Items in Pack <br /> UOM</th>
                    <td mat-cell *matCellDef="let element" class="table-width-p80">
                      {{ element?.itemsInPack }}
                      <span class="block">{{ element?.uom }}</span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="MRP">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p76">
                      MRP
                      <br />
                      <span _ngcontent-ydk-c178="" class="header-placeholder"> (dd/mm/yy)</span>
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-width-p76">
                      <span class="blue-text"
                        *ngIf="element.mrp[selectedCountryName] && element.mrp[selectedCountryName] > 0"> <strong> ₹{{
                          element?.mrp[selectedCountryName] }}</strong></span>
                      <span class="blue-text"
                        *ngIf="!element.mrp[selectedCountryName] || element.mrp[selectedCountryName]==0"> <strong> -
                        </strong></span>

                      <br />
                      {{ element?.mrpDateStr }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="listPrice">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p76">
                      List Price
                      <br />
                      <div class="d-flex">
                        <span class="header-placeholder">
                          (mm/dd/yy)</span>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-width-p76">
                      <span class="blue-text" *ngIf="element.lp && element.lp > 0"> <strong> ₹{{ element?.lp }}
                        </strong></span>
                      <span class="blue-text" *ngIf="element.lp  ==null || element.lp == 0"> <strong> - </strong></span>

                      <br />
                      {{ element?.lpDate }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="TPTxn">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p76">
                      TP Txn
                      <br />
                      <div class="d-flex">
                        <span class="header-placeholder">
                          (yy/mm/dd)</span>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-width-p76">
                      <span *ngIf="element['supplierAvailable']==true"> ₹{{ element['tp'] }} </span>
                      <span *ngIf="element['supplierAvailable']!=true">-</span>
                      <br />
                      {{ element['txn_date'] }}
                    </td>
                  </ng-container>

                  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element"
                      [attr.colspan]="getColumnsToDisplayMapValue(groupDetails.key)?.length">
                      <div class="example-element-detail" [@detailExpand]="
                        element == expandedElement ? 'expanded' : 'collapsed'
                      ">
                        <div class="d-flex element-row w-100">
                          <div class="d-flex justify-between w-100">
                            <div class="d-flex mr-215">
                              <div class="example-element-diagram">
                                <img src="{{imgPrefix}}{{element?.mainImageLink}}" alt=""
                                  onerror="this.src='../../../assets/img/NoImg.png'" />
                              </div>
                              <div class="example-element-description item-detail-row">
                                <h2>{{ element?.productName }}</h2>
                                <div class="mrp-brand-section">
                                  <span>MRP - ₹{{element?.mrp[selectedCountryName]}} | Brand -<span
                                      class="blue-text cursor-pointer">
                                      {{capitalizeFirstLetterOfEachWord( element?.brandName)}} </span> </span>
                                </div>
                                <div class="hsn-info">
                                  HSN- {{element?.productHsn}}, Tax - {{element?.taxPercentage}}%, Items in pack-
                                  {{element?.itemsInPack}}
                                </div>
                                <div class="key-feature-list">
                                  <span>Key Features</span>
                                  <ul *ngIf="element?.keyFeatures?.length > 0">
                                    <li>{{element?.keyFeatures[0]}}</li>
                                    <ng-container
                                      *ngIf="showAllKeyFeaturesForEachMsn[element?.moglixPartNumber]&& element?.keyFeatures?.length > 1">
                                      <li *ngFor="let feature of element?.keyFeatures?.slice(1)">
                                        {{ feature }}
                                      </li>
                                    </ng-container>
                                  </ul>
                                  <a class="see-more-btn" (click)="toggleKeyFeatures(element?.moglixPartNumber)"
                                    *ngIf="element?.keyFeatures?.length > 0">
                                    {{ showAllKeyFeaturesForEachMsn[element?.moglixPartNumber] ? 'See Less' : 'See More'
                                    }}
                                  </a>
                                </div>
                              </div>
                            </div>

                            <div class="flex flex-col">
                              <button class="btn-primary mb-15" mat-raised-button color="warn"
                                (click)="openMsnPdpPage(element?.moglixPartNumber)">
                                View Product Details
                              </button>
                              <button class="btn-outline-primary mb-15" mat-stroked-button color="warn"
                                (click)="productSupplier(element['moglixPartNumber'],element['supplierAvailable'])"
                                [disabled]="!element.supplierAvailable">
                                <span *ngIf="element.supplierAvailable">View Suppliers</span>
                                <span *ngIf="!element.supplierAvailable">No Suppliers</span>
                              </button>
                                                        <button
  mat-button
  class="btn-basic"
  color="Blue2"
  [disabled]="!element.documentInfo?.length"
  (click)="downloadDocument(element.documentInfo[0])">

  <i class="ri-file-download-line icon-left"></i>
  <span [class.text-grey]="!element.documentInfo?.length">
    Technical Document
  </span>
</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="getColumnsToDisplayMapValue(groupDetails.key); sticky: true">
                  </tr>
                  <tr mat-row *matRowDef="let element; columns: getColumnsToDisplayMapValue(groupDetails.key)"
                    class="example-element-row" [class.example-expanded-row]="expandedElement === element"
                    (click)="expandedElement = expandedElement === element ? null : element"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                </table>
              </div>
            </section>

            <!-- Optional: Loading spinner or message
           <div *ngIf="isLoading" class="loading-spinner">Loading...</div> -->

            <section class="varients-group-section" [ngClass]="{'max-height': isExpanded(expandedGroupIdForViewMore) }"
              *ngIf="expandedGroupIdForViewMore">
              <div class="d-flex justify-between w-100">
                <div class="d-flex varients-group-header">
                  <img class="mr-10" src="{{imgPrefix}}{{expandedSingleGroupData[0]?.mainImageLink}}" alt=""
                    onerror="this.src='../../../assets/img/NoImg.png'" />
                  <div>
                    <span>{{capitalizeFirstLetterOfEachWord( expandedSingleGroupData[0]?.brandName)}}</span>
                    <h2>{{expandedSingleGroupData[0]?.cisGroupName}} </h2>
                  </div>
                </div>
                <button mat-button class="btn-basic" (click)="toggleViewLess(expandedSingleGroupData[0].cisIdGroup)"
                  color="Blue2">
                  View Less
                </button>

              </div>
              <div class="mog3_msnsearchtable product-varient-table-section " [ngClass]="{'table-max-height': isExpanded(expandedGroupIdForViewMore),
                  'table-min-height': !isExpanded(expandedGroupIdForViewMore)}" (scroll)="onScrollSingleGroup($event)">
                <table mat-table [dataSource]="expandedSingleGroupData" multiTemplateDataRows>
                  <ng-container matColumnDef="MSNItemDescription">
                    <th mat-header-cell *matHeaderCellDef>
                      MSN <br /> Item Description
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <span class="font-500 d-flex">
                        {{ element.moglixPartNumber }}
                      </span>
                      <!-- <span class="link text-truncate"
                      matTooltip="{{element?.productName}}"
                      [matTooltipPosition]="'right'"
                      matTooltipHideDelay="10">{{ element.productName }}
                      </span> -->
                      <div class="atom-tooltip">
                        <span class="link text-truncate "> {{ element?.productName }}
                          <span class="atom-tooltiptext tooltip-right table-tooltip">{{ element?.productName }}</span>
                        </span>
                      </div>
                    </td>
                  </ng-container>

                  <ng-container *ngFor="let column of dynamicColumnsForSingleGroup; let i= index"
                    matColumnDef="{{column}}">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p71">
                      <div class="flex items-center">
                        {{capitalizeFirstLetterOfEachWord(column)}}
                        <a mat-icon-button class="table-header-sort">
                          <i class="ri-arrow-up-down-fill"
                            (click)="displaySortedSingleGroupDetails(expandedGroupIdForViewMore,column)"></i>
                        </a>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-width-p71">
                      {{ element?.attributeValuesForPart[column]}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="uom">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p80">Items in Pack <br /> UOM</th>
                    <td mat-cell *matCellDef="let element" class="table-width-p80">
                      {{element?.itemsInPack}}
                      <span class="block">{{ element?.uom }}</span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="MRP">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p76">
                      MRP
                      <br />
                      <span _ngcontent-ydk-c178="" class="header-placeholder"> (dd/mm/yy)</span>
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-width-p76">
                      <span class="blue-text"
                        *ngIf="element.mrp[selectedCountryName] && element.mrp[selectedCountryName] > 0"> <strong> ₹{{
                          element?.mrp[selectedCountryName] }}</strong></span>
                      <span class="blue-text"
                        *ngIf="!element.mrp[selectedCountryName] || element.mrp[selectedCountryName]==0"> <strong> -
                        </strong></span>

                      <br />
                      {{ element?.mrpDateStr }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="listPrice">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p76">
                      List Price
                      <br />
                      <div class="d-flex">
                        <span class="header-placeholder">
                          (mm/dd/yy)</span>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-width-p76">
                      <span class="blue-text" *ngIf="element.lp && element.lp > 0"> <strong> ₹{{ element?.lp }}
                        </strong></span>
                      <span class="blue-text" *ngIf="element.lp  ==null || element.lp == 0"> <strong> - </strong></span>

                      <br />
                      {{ element?.lpDate }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="TPTxn">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p76">
                      TP Txn
                      <br />
                      <div class="d-flex">
                        <span class="header-placeholder">
                          (yy/mm/dd)</span>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-width-p76">
                      <span *ngIf="element['supplierAvailable']==true"> ₹{{ element['tp'] }} </span>
                      <span *ngIf="element['supplierAvailable']!=true">-</span>
                      <br />
                      {{ element['txn_date'] }}
                    </td>
                  </ng-container>

                  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                      <div class="example-element-detail" [@detailExpand]="
                        element == expandedElement ? 'expanded' : 'collapsed'
                      ">
                        <div class="d-flex element-row w-100">
                          <div class="d-flex justify-between w-100">
                            <div class="d-flex mr-215">
                              <div class="example-element-diagram">
                                <img src="{{imgPrefix}}{{element?.mainImageLink}}" alt=""
                                  onerror="this.src='../../../assets/img/NoImg.png'" />
                              </div>
                              <div class="example-element-description item-detail-row">
                                <h2>{{ element?.productName }}</h2>
                                <div class="mrp-brand-section">
                                  <span>MRP - ₹{{element?.mrp[selectedCountryName]}} | Brand -
                                    <a class="blue-text cursor-pointer">
                                      {{capitalizeFirstLetterOfEachWord( element?.brandName)}} </a> </span>
                                </div>
                                <div class="hsn-info">
                                  HSN- {{element?.productHsn}}, Tax - {{element?.taxPercentage}}%, Items in pack-
                                  {{element?.itemsInPack}}
                                </div>
                                <div class="key-feature-list">
                                  <span>Key Features</span>
                                  <ul *ngIf="element?.keyFeatures?.length > 0">
                                    <li>{{element?.keyFeatures[0]}}</li>
                                    <ng-container
                                      *ngIf="showAllKeyFeaturesForEachMsn[element?.moglixPartNumber]&& element?.keyFeatures?.length > 1">
                                      <li *ngFor="let feature of element?.keyFeatures?.slice(1)">
                                        {{ feature }}
                                      </li>
                                    </ng-container>
                                  </ul>
                                  <a class="see-more-btn" (click)="toggleKeyFeatures(element?.moglixPartNumber)"
                                    *ngIf="element?.keyFeatures?.length > 0">
                                    {{ showAllKeyFeaturesForEachMsn[element?.moglixPartNumber] ? 'See Less' : 'See More'
                                    }}
                                  </a>
                                </div>
                              </div>
                            </div>

                            <div class="flex flex-col">
                              <button class="btn-primary mb-15" mat-raised-button color="warn"
                                (click)="openMsnPdpPage(element?.moglixPartNumber)">
                                View Product Details
                              </button>
                              <button class="btn-outline-primary mb-15" mat-stroked-button color="warn"
                                (click)="productSupplier(element['moglixPartNumber'],element['supplierAvailable'])"
                                [disabled]="!element.supplierAvailable">
                                <span *ngIf="element.supplierAvailable">View Suppliers</span>
                                <span *ngIf="!element.supplierAvailable">No Suppliers</span>
                              </button>
                                                        <button
  mat-button
  class="btn-basic"
  color="Blue2"
  [disabled]="!element.documentInfo?.length"
  (click)="downloadDocument(element.documentInfo[0])">

  <i class="ri-file-download-line icon-left"></i>
  <span [class.text-grey]="!element.documentInfo?.length">
    Technical Document
  </span>
</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                  <tr mat-row *matRowDef="let element; columns: displayedColumns" class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element" (click)="
                    expandedElement =
                      expandedElement === element ? null : element
                  "></tr>
                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                </table>
              </div>
            </section>

            <section class="varients-group-section max-height" *ngIf="singleVariantFlag" style="height: 100%;">
              <div class="d-flex justify-between w-100">

                <div class="d-flex varients-group-header ">

                  <h2 class="mb-0">Other Products</h2>

                </div>
              </div>
              <!-- <button mat-button class="btn-basic" color="Blue2">
                {{ viewMore ? 'View More' : 'View Less' }}
              </button> -->
              <div class="mog3_msnsearchtable product-varient-table-section max-height"
                (scroll)="onScrollSingleVariant($event)">
                <table mat-table [dataSource]="singleVariantsData" multiTemplateDataRows>
                  <ng-container matColumnDef="Images">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p55">
                      Images
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-width-p55">
                      <span class="font-500 d-flex">
                        <img src="{{imgPrefix}}{{element?.mainImageLink}}" alt=""
                          onerror="this.src='../../../assets/img/NoImg.png'" class="mr-10 table-img">
                      </span>

                    </td>
                  </ng-container>

                  <ng-container matColumnDef="MSN">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p80">MSN</th>
                    <td mat-cell *matCellDef="let element" class="table-width-p80">
                      {{ element?.moglixPartNumber }}

                    </td>
                  </ng-container>

                  <ng-container matColumnDef="ItemDescription">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p120">Item Description</th>
                    <td mat-cell *matCellDef="let element" class="table-width-p120">
                      <div class="atom-tooltip">
                        <span class="link text-truncate "> {{ element?.productName }}
                          <span class="atom-tooltiptext tooltip-right table-tooltip">{{ element?.productName }}</span>
                        </span>
                      </div>


                    </td>
                  </ng-container>



                  <ng-container matColumnDef="uom">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p55">Items in Pack <br /> UOM</th>
                    <td mat-cell *matCellDef="let element" class="table-width-p55">
                      {{element?.itemsInPack}}
                      <span class="block">{{ element?.uom }}</span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="MRP">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p76">
                      MRP
                      <br />
                      <span _ngcontent-ydk-c178="" class="header-placeholder"> (dd/mm/yy)</span>
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-width-p76">
                      <span class="blue-text"
                        *ngIf="element.mrp[selectedCountryName] && element.mrp[selectedCountryName] > 0"> <strong> ₹{{
                          element?.mrp[selectedCountryName] }}</strong></span>
                      <span class="blue-text"
                        *ngIf="!element.mrp[selectedCountryName] || element.mrp[selectedCountryName]==0"> <strong> -
                        </strong></span>

                      <br />
                      {{ element?.mrpDateStr }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="listPrice">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p76">
                      List Price
                      <br />
                      <div class="d-flex">
                        <span class="header-placeholder">
                          (mm/dd/yy)</span>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-width-p76">
                      <span class="blue-text" *ngIf="element.lp && element.lp > 0"> <strong> ₹{{ element?.lp }}
                        </strong></span>
                      <span class="blue-text" *ngIf="element.lp  ==null || element.lp == 0"> <strong> - </strong></span>

                      <br />
                      {{ element?.lpDate }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="TPTxn">
                    <th mat-header-cell *matHeaderCellDef class="table-width-p76">
                      TP Txn
                      <br />
                      <div class="d-flex">
                        <span class="header-placeholder">
                          (yy/mm/dd)</span>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-width-p76">
                      <span *ngIf="element['supplierAvailable']==true"> ₹{{ element['tp'] }}</span>
                      <span *ngIf="element['supplierAvailable']!=true">-</span>
                      <br />
                      {{ element['txn_date'] }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="singleVarientColumnsToDisplay.length">
                      <div class="example-element-detail" [@detailExpand]="
                        element == expandedElement ? 'expanded' : 'collapsed'
                      ">
                        <div class="d-flex element-row w-100">
                          <div class="d-flex justify-between w-100">
                            <div class="d-flex mr-215">
                              <div class="example-element-diagram">
                                <img src="{{imgPrefix}}{{element?.mainImageLink}}" alt="" />
                              </div>
                              <div class="example-element-description item-detail-row">
                                <h2>{{element?.productName}}</h2>
                                <div class="mrp-brand-section">
                                  <span>MRP - ₹{{ element?.mrp[selectedCountryName] }} | Brand -
                                    <span class="blue-text cursor-pointer">
                                      {{capitalizeFirstLetterOfEachWord( element?.brandName)}} </span> </span>
                                </div>
                                <div class="hsn-info">
                                  HSN- {{element?.productHsn}}, Tax - {{element?.taxPercentage}}%, Items in pack-
                                  {{element?.itemsInPack}}
                                </div>
                                <div class="key-feature-list">
                                  <span>Key Features</span>
                                  <ul *ngIf="element?.keyFeatures?.length > 0">
                                    <li>{{element?.keyFeatures[0]}}</li>
                                    <ng-container
                                      *ngIf="showAllKeyFeaturesForEachMsn[element?.moglixPartNumber]&& element?.keyFeatures?.length > 1">
                                      <li *ngFor="let feature of element?.keyFeatures?.slice(1)">
                                        {{ feature }}
                                      </li>
                                    </ng-container>
                                  </ul>
                                  <a class="see-more-btn" (click)="toggleKeyFeatures(element?.moglixPartNumber)"
                                    *ngIf="element?.keyFeatures?.length > 0">
                                    {{ showAllKeyFeaturesForEachMsn[element?.moglixPartNumber] ? 'See Less' : 'See More'
                                    }}
                                  </a>
                                </div>
                              </div>
                            </div>

                            <div class="flex flex-col">
                              <button class="btn-primary mb-15" mat-raised-button color="warn"
                                (click)="openMsnPdpPage(element?.moglixPartNumber)">
                                View Product Details
                              </button>
                              <button class="btn-outline-primary mb-15" mat-stroked-button color="warn"
                                (click)="productSupplier(element['moglixPartNumber'],element['supplierAvailable'])"
                                [disabled]="!element.supplierAvailable">
                                <span *ngIf="element.supplierAvailable">View Suppliers</span>
                                <span *ngIf="!element.supplierAvailable">No Suppliers</span>
                              </button>
                             <button
  mat-button
  class="btn-basic"
  color="Blue2"
  [disabled]="!element.documentInfo?.length"
  (click)="downloadDocument(element.documentInfo[0])">

  <i class="ri-file-download-line icon-left"></i>
  <span [class.text-grey]="!element.documentInfo?.length">
    Technical Document
  </span>
</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="singleVarientColumnsToDisplay; sticky: true"></tr>
                  <tr mat-row *matRowDef="let element; columns: singleVarientColumnsToDisplay"
                    class="example-element-row" [class.example-expanded-row]="expandedElement === element" (click)="
                    expandedElement =
                      expandedElement === element ? null : element
                  "></tr>
                  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                </table>
              </div>
            </section>

          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</section>